import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "product-extra-content-block" }
const _hoisted_2 = { class: "product-extra-content-block__row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_extra_content_item = _resolveComponent("product-extra-content-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["product-extra-content-block__item-container", {
          'product-extra-content-block__item-container--just-one': _ctx.justOneItem,
          [`product-extra-content-block__item--${index + 1}`]: !_ctx.justOneItem
        }])
        }, [
          _createVNode(_component_product_extra_content_item, { content: content }, null, 8 /* PROPS */, ["content"])
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}